import { Model } from 'modules/core/lib/mobx-rest'

interface IEmployeeStat {
  [key: string]: any
}

class EmployeeStat extends Model<IEmployeeStat> {
  static urlRoot() {
    return '/attendance/custom_periods/employee_stats'
  }
}

export default EmployeeStat
